import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import lightTheme from '@/themes/light';
import darkTheme from '@/themes/dark';

Vue.use(Vuetify);

var useDarkTheme = false;

/*
try
{
    const theme = window.localStorage.getItem("andytruong.user.theme-name");
    if (theme != null)
        useDarkTheme = theme.toLowerCase() == "dark";
}
catch
{
    useDarkTheme = false;
}
*/

export default new Vuetify({
    theme: { 
        options: {
            customProperties: true,
        },
        themes: {
            light: lightTheme,
            dark: darkTheme
        },
        dark: useDarkTheme 
    }
});
